import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {ErrorBoundary as ReactErrorBoundary} from 'react-error-boundary';
import {ErrorBoundaryFallbackContainer} from '@Components/error-boundary-fallback-container/error-boundary-fallback-container';
import {QRCodeGenerator} from '@Components/qr-code-generator/qr-code-generator';
import {clearQRGeneratorSession} from '@Components/qr-code-generator/qr-generator-session.library';
import {
  QR_CODE_GENERATOR_CONTAINER_ID,
  QR_DEFAULT_TYPE_DATA_ATTRIBUTE,
  QR_SOCIAL_ICON_BASE_URL_DATA_ATTRIBUTE,
  QR_TEMPLATE_TILES_DATA_ATTRIBUTE,
} from '@Components/qr-code-generator/qr-code-generator.types';
import {getDefaultActiveType, parseDesignTileSets} from '@Components/qr-code-generator/qr-code-generator.library';
import {whenTranslationsReady} from '@Utils/translations-ready.util';

const container = document.getElementById(QR_CODE_GENERATOR_CONTAINER_ID);

const getSocialIconBaseUrl = (mountPoint: HTMLElement): string => {
  const baseUrl = mountPoint.dataset[QR_SOCIAL_ICON_BASE_URL_DATA_ATTRIBUTE];
  if (baseUrl === undefined || baseUrl === '') {
    window.PMW.log(
      'QR tool: no social icon base URL on the mount point, so codes will carry no platform logo. The page HTML is probably cached from before the attribute was added.'
    );
    return '';
  }
  return baseUrl;
};

const onToolError = (error: Error): void => {
  window.PMW.log('The QR tool stopped rendering', error);
};

const onFallbackReload = (): void => {
  clearQRGeneratorSession();
  window.location.reload();
};

if (container) {
  const mountPoint = container;
  whenTranslationsReady((): void => {
    createRoot(mountPoint).render(
      <StrictMode>
        <ReactErrorBoundary fallback={<ErrorBoundaryFallbackContainer onReload={onFallbackReload} />} onError={onToolError}>
          <QRCodeGenerator
            socialIconBaseUrl={getSocialIconBaseUrl(mountPoint)}
            templateTileSets={parseDesignTileSets(mountPoint.dataset[QR_TEMPLATE_TILES_DATA_ATTRIBUTE])}
            defaultActiveType={getDefaultActiveType(mountPoint.dataset[QR_DEFAULT_TYPE_DATA_ATTRIBUTE])}
          />
        </ReactErrorBoundary>
      </StrictMode>
    );
  });
}
